/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import styled from 'styled-components';
export const ButtonGroupBase = styled.div `
  display: inline-flex;
  border-radius: 4px;
  &.border {
    border: 1px solid #ccc;
  }
  &.separate {
    & > button,
    & > div {
      border-radius: 4px;
      position: relative;
      &:not(:first-of-type):before {
        content: " ";
        display: block;
        width: 1px;
        height: 12px;
        position: absolute;
        top: 50%;
        left: -1px;
        background: #e6e6e6;
        z-index: 3;
        transform: translateY(-50%);
        opacity: 1!important;
      }
    }
  }
  & > button,
  & > div {
    border-radius: 4px;
    &:not(:last-of-type) {
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      border-right-color: transparent;
    }
    &:not(:first-of-type) {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      margin-left: -1px;
    }
  }
`;
